import { render, staticRenderFns } from "./PrimaryNavItemWithTitle.vue?vue&type=template&id=6126b0bc&scoped=true&"
import script from "./PrimaryNavItemWithTitle.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavItemWithTitle.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryNavItemWithTitle.vue?vue&type=style&index=0&id=6126b0bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6126b0bc",
  null
  
)

export default component.exports